import styles from './BoardMembers.module.scss'
import React, { useEffect, useRef, useMemo } from 'react'
import BasicTitle from 'components/about/BasicTitle/BasicTitle'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'

interface Member {
  officer: string
  director?: string
  name: string
  nameEng: string
  img: string
  description: string
  num: number
  adjust?: boolean
}

const members: Member[] = [
  {
    num: 1,
    director: '取締役',
    officer: 'CHRO/CSO(Strategy)',
    name: '門間 克明',
    nameEng: 'Yoshiaki Momma',
    img: '/img/about/board_momma.webp',
    description:
      'IT関連上場企業の人事部門にて採用・人材育成・キャリア開発、人事制度設計に従事。人事を中心に活動する傍ら、総務・法務・経営企画・情報システム部門の責任者も兼任し、バックオフィス部門を統括する立場として管理部長に就任。人事領域だけでなくコーポレート業務全般に広い知見を持つ。2023年1月から当社のボードメンバーとして加わり、2024年8月より取締役就任。',
  },
  {
    num: 2,
    director: '執⾏役員',
    officer: 'Digital Engineering 本部長',
    name: '西尾 智春',
    nameEng: 'Tomoharu Nishio',
    img: '/img/about/board_nishio.webp',
    description:
      '国内SIerにて、大手ECシステムのプロジェクトマネジメントに従事。その後、D2C系ベンチャー企業の取締役CTOに就任。システム戦略の全体を統括する立場で、基幹・物流・EC・店舗システムのオムニチャネル化を推進。2018年12月より国内SIerにてAI事業の立ち上げに携わる。当社への入社後は、エンジニアリング部門の組織づくりを中心に、エンタープライズ向けアプリケーションの開発手法やAI駆動開発プロセスの整備、提案活動と広く取り組む。',
  },
  {
    num: 3,
    director: '常勤監査役',
    officer: '',
    name: '大塚 忠明',
    nameEng: 'Tadaaki Otsuka',
    img: '/img/about/board_otsuka.webp',
    description:
      '日本アイ・ビー・エム、伊藤忠テクノソリューションズで営業、グローバルビジネス、監査と幅広い分野で要職を担当。伊藤忠テクノソリューションズでは執行役員として、CTCアメリカ社長、監査本部長を歴任。USCPA（米国公認会計士）等のコーポレートガバナンスに係る資格を取得。2025年11月、当社常勤監査役に就任。',
  },
  {
    num: 4,
    director: '監査役',
    officer: '',
    name: '高橋 京子',
    nameEng: 'Kyoko Takahashi',
    img: '/img/about/board_takahashi.webp',
    description:
      '住友海上火災保険株式会社（現 三井住友海上火災保険）に入社、経営企画部でコーポレートガバナンス関連業務に長年従事。その後、品質管理部門、監査部部長、監査役室長、MS&ADシステムズ株式会社取締役を経て、現在、株式会社シンカ常勤監査役を務める。2023年10月、当社監査役に就任。',
  },
  {
    num: 5,
    director: '監査役',
    officer: '',
    name: '市川 圭介',
    nameEng: 'Keisuke Ichikawa',
    img: '/img/about/board_ichikawa.webp',
    description:
      '公認会計士。大手監査法人、経営コンサルティング会社を経て独立し、事業再生や経営支援、ベンチャー企業の成長支援などに従事。2016年より株式会社インターメディカル代表取締役に就任。これまで複数企業の経営に携わり、現在は上場企業の社外役員として、ガバナンス強化や企業価値向上にも取り組んでいる。2026年11月、当社監査役に就任。',
  },
]

const BoardMembers: React.FC = () => {
  const imgRef = useRef<HTMLDivElement | null>(null)
  const isVisible = useElementVisible(imgRef, 0.1)

  const memberRefs = useMemo(() => members.map(() => React.createRef<HTMLDivElement>()), [])
  const memberVisibility = memberRefs.map((ref) => useElementVisible(ref, 0.1))

  const memberlist = members.map((m, index) => (
    <div
      key={index}
      ref={memberRefs[index]}
      className={`
        ${styles.member_card}
        ${animationStyles.fade}
        ${memberVisibility[index] ? animationStyles.fadeOn : ''}
      `}
    >
      <div className={styles.member_item}>
        <div className={styles.top_content}>
          <div className={styles.icon}>
            <img src={m.img} alt={m.name} />
          </div>
          <div className={styles.director}>
            <div className={styles.director_text}>
              <p className={styles.director_text_director}>{m.director}</p>
              <p className={styles.director_text_officer}> {m.officer}</p>
            </div>
            <div className={styles.director_prof}>
              <div className={styles.name_text}>{m.name}</div>
              <div className={styles.nameEng_text}>{m.nameEng}</div>
            </div>
          </div>
        </div>
        <div className={styles.description}>{m.description}</div>
      </div>
    </div>
  ))

  const sectionTitle = {
    title: 'Board members',
    sub_title: '役員紹介',
  }

  return (
    <section className={styles.contents} id="member_top">
      <section className={`${styles.group_office}`}>
        <div className={styles.title_group}>
          <BasicTitle sectionTitle={sectionTitle} />
        </div>
      </section>
      <div className={styles.item_container}>
        <div className={styles.member_container}>{memberlist}</div>
      </div>
    </section>
  )
}

export default BoardMembers
